/**
 * Get the range of items for pagination
 * This function calculates the start and end index for a given page and items per page.
 * It returns a string formatted as "startIndex, endIndex".
 *
 * @param {number} page - The current page number (0-based index).
 * @param {number} itemsPerPage - The number of items per page.
 * @return {string} - A string representing the range of items for pagination.
 **/

export function getItemRange(page, itemsPerPage) {
    // Calculate the start and end index for the given page
    const startIndex = page * itemsPerPage;

    // Ensure the endIndex does not exceed the total number of items
    const endIndex = startIndex + itemsPerPage;

    // Return the range as a string
    return `${startIndex}, ${endIndex - 1}`;
}
